export default __webpack_public_path__ + "static/media/ambulant.6ada430c.svg";